// Exact BigInt port of contracts/src/libraries/CurveMath.sol.
import { BPS, CURVE_FEE_BPS, CURVE_SUPPLY, LOT, VIRTUAL_QUOTE_0, VIRTUAL_TOKEN_0 } from "./params";

const divUp = (a: bigint, b: bigint) => (a === 0n ? 0n : (a - 1n) / b + 1n);

export const virtualToken = (sold: bigint) => VIRTUAL_TOKEN_0 - sold;
export const virtualQuote = (reserve: bigint) => VIRTUAL_QUOTE_0 + reserve;

export function buyCost(sold: bigint, reserve: bigint, amount: bigint): bigint {
  const vT = virtualToken(sold);
  return divUp(virtualQuote(reserve) * amount, vT - amount);
}

export function sellPayout(sold: bigint, reserve: bigint, amount: bigint): bigint {
  return (virtualQuote(reserve) * amount) / (virtualToken(sold) + amount);
}

export const curveFee = (amount: bigint) => divUp(amount * CURVE_FEE_BPS, BPS);

/** quote wei per 1e18 token units */
export const spotPrice = (sold: bigint, reserve: bigint) => (virtualQuote(reserve) * 10n ** 18n) / virtualToken(sold);

export function nextLot(sold: bigint): bigint {
  const rem = CURVE_SUPPLY - sold;
  return rem > LOT ? LOT : rem;
}

export function quoteBuy(sold: bigint, reserve: bigint) {
  const amount = nextLot(sold);
  if (amount === 0n) return { amount, cost: 0n, fee: 0n, total: 0n };
  const cost = buyCost(sold, reserve, amount);
  const fee = curveFee(cost);
  return { amount, cost, fee, total: cost + fee };
}

export function quoteSell(sold: bigint, reserve: bigint, amount: bigint) {
  if (amount === 0n || amount > sold) return { gross: 0n, fee: 0n, out: 0n };
  const gross = sellPayout(sold, reserve, amount);
  let fee = curveFee(gross);
  if (fee > gross) fee = gross;
  return { gross, fee, out: gross - fee };
}

export const progress = (sold: bigint) => Number((sold * 1_000_000n) / CURVE_SUPPLY) / 1_000_000;
